import { ClientType, FrontPage } from '@upright/ui/views/home-views/front-page-config';
import { generateHomeUrl } from './frontpage-links';
import { createInvestorSectionTitle } from './investor-section';
import { Item, ItemLink, Section, MenuTitleSmall } from '../../../shared-menus';

interface Props {
  clientType: ClientType;
  frontPage: FrontPage;
  organizationName: string | undefined;
}

export const InvestorBlock = (props: Props) => {
  const investorTitle = createInvestorSectionTitle(props.clientType, props.organizationName);
  const isInvestorFrontPage = props.frontPage === 'investor';
  return (
    <Section>
      <MenuTitleSmall>{investorTitle}</MenuTitleSmall>
      <Item>
        <ItemLink to={generateHomeUrl({ entity: 'investor', isInvestorFrontPage })}>
          {props.organizationName || 'Organization'}'s assets
        </ItemLink>
      </Item>
    </Section>
  );
};
